import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteShopProductByIdMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type DeleteShopProductByIdMutation = { __typename?: 'mutation_root', delete_shop_products_by_pk?: { __typename?: 'shop_products', id: any } | null };


export const DeleteShopProductByIdDocument = gql`
    mutation deleteShopProductById($id: uuid!) {
  delete_shop_products_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteShopProductByIdMutationFn = Apollo.MutationFunction<DeleteShopProductByIdMutation, DeleteShopProductByIdMutationVariables>;

/**
 * __useDeleteShopProductByIdMutation__
 *
 * To run a mutation, you first call `useDeleteShopProductByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShopProductByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShopProductByIdMutation, { data, loading, error }] = useDeleteShopProductByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteShopProductByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteShopProductByIdMutation, DeleteShopProductByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteShopProductByIdMutation, DeleteShopProductByIdMutationVariables>(DeleteShopProductByIdDocument, options);
      }
export type DeleteShopProductByIdMutationHookResult = ReturnType<typeof useDeleteShopProductByIdMutation>;
export type DeleteShopProductByIdMutationResult = Apollo.MutationResult<DeleteShopProductByIdMutation>;
export type DeleteShopProductByIdMutationOptions = Apollo.BaseMutationOptions<DeleteShopProductByIdMutation, DeleteShopProductByIdMutationVariables>;